import { render, staticRenderFns } from "./CardCertificates.vue?vue&type=template&id=41453c8e&scoped=true&"
import script from "./CardCertificates.vue?vue&type=script&lang=js&"
export * from "./CardCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41453c8e",
  null
  
)

export default component.exports